// import React, { useContext, useEffect, useState, useCallback } from "react";
// import { FaTrash } from "react-icons/fa";
// import axios from "axios";
// import { AuthContext } from "../context/AuthContext";
// import { API_URL } from "../../Constants";

// export default function BlacklistPage() {
//   const { user } = useContext(AuthContext);
//   const [blacklistData, setBlacklistData] = useState([]);

//   const fetchBlacklistData = useCallback(async () => {
//     try {
//       const url =
//         user?.accountType === "COMPANY"
//           ? `${API_URL}/api/blacklist/company/${user?.id}`
//           : `${API_URL}/api/blacklist/user/${user?.id}`;

//       const token = localStorage.getItem("token");
//       const res = await axios.get(url, {
//         headers: {
//           Authorization: `Bearer ${token}`,
//         },
//       });

//       setBlacklistData(res.data.leads || []);
//     } catch (error) {
//       console.error("Failed to fetch blacklist data:", error);
//     }
//   }, [user]);

//   useEffect(() => {
//     if (user) {
//       fetchBlacklistData();
//     }
//   }, [user, fetchBlacklistData]);

//   const handleDelete = async (id) => {
//     try {
//       const token = localStorage.getItem("token");
//       await axios.delete(`${API_URL}/api/blacklist/unBlackListLead/${id}`, {
//         headers: {
//           Authorization: `Bearer ${token}`,
//         },
//       });
//       fetchBlacklistData();
//     } catch (error) {
//       console.error("Failed to delete lead:", error);
//     }
//   };

//   const formatDate = (date) => {
//     if (!date) return "-";
//     const d = new Date(date);
//     const day = String(d.getDate()).padStart(2, "0");
//     const month = String(d.getMonth() + 1).padStart(2, "0");
//     const year = d.getFullYear();
//     return `${day}-${month}-${year}`;
//   };

//   return (
//     <div className="p-4 mx-auto bg-gray-100 dark:bg-gray-900 dark:text-white shadow-lg">
//       <div className="flex justify-between items-center mb-4">
//         <h2 className="text-xl font-bold">🔒 Blacklist Leads</h2>
//       </div>
//       <div className="overflow-x-auto shadow-lg rounded">
//         <table className="w-full table-auto border-collapse bg-white dark:bg-gray-900 dark:text-white">
//           <thead className="bg-gray-50 text-sm text-left dark:bg-gray-900 dark:text-white">
//             <tr className=" text-sm">
//               <th className="p-2">S No.</th>
//               <th className="p-2">Lead Name</th>
//               <th className="p-2">Email</th>
//               <th className="p-2">Phone</th>
//               <th className="p-2">Assigned To</th>
//               <th className="p-2">Source</th>
//               <th className="p-2">Blacklisted Reason</th>
//               <th className="p-2">Blacklisted By</th>
//               <th className="p-2">Date</th>
//               <th className="p-2">Actions</th>
//             </tr>
//           </thead>
//           <tbody>
//             {blacklistData.length > 0 ? (
//               blacklistData.map((item, index) => (
//                 <tr
//                   key={index}
//                   className="hover:bg-gray-50 text-sm dark:hover:bg-gray-500 text-[13px]"
//                 >
//                   <td className="p-2">{index + 1}.</td>
//                   <td className="p-2">{item.lead?.name}</td>
//                   <td className="p-2">{item.lead?.email}</td>
//                   <td className="p-2">{item.lead?.phone}</td>
//                   <td className="p-2">{item.lead?.assignedToName}</td>
//                   <td className="p-2">{item.lead?.sourceName}</td>
//                   <td className="p-2">{item.blackListLead?.reason}</td>
//                   <td className="p-2">{item.blackListLead?.createdByName}</td>
//                   <td className="p-2">
//                     {/* {     new Date(item.lead?.createdAt).toLocaleDateString()} */}
//                     {formatDate(item.lead?.createdAt)}
//                   </td>
//                   {user?.accountType === "COMPANY" ? (
//                     <td className="p-2">
//                       <button
//                         onClick={() =>
//                           handleDelete(item.blackListLead?.blackListLeadId)
//                         }
//                         className="text-red-600 hover:text-red-800"
//                       >
//                         <FaTrash />
//                       </button>
//                     </td>
//                   ) : null}
//                 </tr>
//               ))
//             ) : (
//               <tr>
//                 <td colSpan="11" className="text-center p-4 text-gray-500">
//                   No blacklisted leads found.
//                 </td>
//               </tr>
//             )}
//           </tbody>
//         </table>
//       </div>
//     </div>
//   );
// }





import React, { useContext, useEffect, useState, useCallback } from "react";
import { FaTrash } from "react-icons/fa";
import axios from "axios";
import { AuthContext } from "../context/AuthContext";
import { API_URL } from "../../Constants";

export default function BlacklistPage() {
  const { user } = useContext(AuthContext);
  const [blacklistData, setBlacklistData] = useState([]);

  const fetchBlacklistData = useCallback(async () => {
    try {
      const url =
        user?.accountType === "COMPANY"
          ? `${API_URL}/api/blacklist/company/${user?.id}`
          : `${API_URL}/api/blacklist/user/${user?.id}`;

      const token = localStorage.getItem("token");
      const res = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      setBlacklistData(res.data.leads || []);
    } catch (error) {
      console.error("Failed to fetch blacklist data:", error);
    }
  }, [user]);

  useEffect(() => {
    if (user) {
      fetchBlacklistData();
    }
  }, [user, fetchBlacklistData]);

  const handleDelete = async (id) => {
    try {
      const token = localStorage.getItem("token");
      await axios.delete(`${API_URL}/api/blacklist/unBlackListLead/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      fetchBlacklistData();
    } catch (error) {
      console.error("Failed to delete lead:", error);
    }
  };

  const formatDate = (date) => {
    if (!date) return "-";
    const d = new Date(date);
    const day = String(d.getDate()).padStart(2, "0");
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const year = d.getFullYear();
    return `${day}-${month}-${year}`;
  };

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Sora:wght@600;700&family=Inter:wght@400;500;600&display=swap'); 
        .cfg-heading { font-family: 'Sora', sans-serif; } 
        .cfg-font { font-family: 'Inter', sans-serif; }
      `}</style>

      <div className="w-full min-h-screen bg-[#FAF8FF] dark:bg-gray-900 p-4 md:p-6 lg:p-8 cfg-font">
        <div className="max-w-7xl mx-auto space-y-6">
          
          {/* Header */}
          <div className="flex flex-col sm:flex-row justify-between items-center gap-4 mb-2">
            <h1 className="text-2xl sm:text-3xl font-bold cfg-heading text-[#1F2937] dark:text-white flex items-center gap-2">
              🔒 Blacklist Leads
            </h1>
          </div>

          {/* Table Container */}
          <div className="bg-white rounded-xl shadow-sm border border-[#E5E7EB] dark:bg-gray-800 dark:border-gray-700 overflow-hidden">
            <div className="overflow-x-auto scrollbar-thin scrollbar-thumb-[#E5E7EB] dark:scrollbar-thumb-gray-600">
              <table className="min-w-full divide-y divide-[#E5E7EB] dark:divide-gray-700">
                <thead className="bg-[#FAF8FF] dark:bg-gray-700/50">
                  <tr>
                    <th className="px-4 py-3.5 text-left text-[11px] sm:text-xs font-bold text-[#4B5563] dark:text-gray-300 uppercase tracking-wider">S No.</th>
                    <th className="px-4 py-3.5 text-left text-[11px] sm:text-xs font-bold text-[#4B5563] dark:text-gray-300 uppercase tracking-wider">Lead Name</th>
                    <th className="px-4 py-3.5 text-left text-[11px] sm:text-xs font-bold text-[#4B5563] dark:text-gray-300 uppercase tracking-wider">Email</th>
                    <th className="px-4 py-3.5 text-left text-[11px] sm:text-xs font-bold text-[#4B5563] dark:text-gray-300 uppercase tracking-wider">Phone</th>
                    <th className="px-4 py-3.5 text-left text-[11px] sm:text-xs font-bold text-[#4B5563] dark:text-gray-300 uppercase tracking-wider">Assigned To</th>
                    <th className="px-4 py-3.5 text-left text-[11px] sm:text-xs font-bold text-[#4B5563] dark:text-gray-300 uppercase tracking-wider">Source</th>
                    <th className="px-4 py-3.5 text-left text-[11px] sm:text-xs font-bold text-[#4B5563] dark:text-gray-300 uppercase tracking-wider">Blacklisted Reason</th>
                    <th className="px-4 py-3.5 text-left text-[11px] sm:text-xs font-bold text-[#4B5563] dark:text-gray-300 uppercase tracking-wider">Blacklisted By</th>
                    <th className="px-4 py-3.5 text-left text-[11px] sm:text-xs font-bold text-[#4B5563] dark:text-gray-300 uppercase tracking-wider">Date</th>
                    {user?.accountType === "COMPANY" && (
                      <th className="px-4 py-3.5 text-left text-[11px] sm:text-xs font-bold text-[#4B5563] dark:text-gray-300 uppercase tracking-wider">Actions</th>
                    )}
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-[#E5E7EB] dark:bg-gray-800 dark:divide-gray-700">
                  {blacklistData.length > 0 ? (
                    blacklistData.map((item, index) => (
                      <tr
                        key={index}
                        className="hover:bg-[#F3E8FF]/30 dark:hover:bg-gray-700/50 transition text-[13px] sm:text-sm"
                      >
                        <td className="px-4 py-3 whitespace-nowrap font-medium text-[#6B7280] dark:text-gray-400">
                          {index + 1}.
                        </td>
                        <td className="px-4 py-3 whitespace-nowrap font-bold text-[#1F2937] dark:text-white">
                          {item.lead?.name || "-"}
                        </td>
                        <td className="px-4 py-3 whitespace-nowrap text-[#4B5563] dark:text-gray-300">
                          {item.lead?.email || "-"}
                        </td>
                        <td className="px-4 py-3 whitespace-nowrap font-medium text-[#4B5563] dark:text-gray-300">
                          {item.lead?.phone || "-"}
                        </td>
                        <td className="px-4 py-3 whitespace-nowrap text-[#4B5563] dark:text-gray-300">
                          {item.lead?.assignedToName || "-"}
                        </td>
                        <td className="px-4 py-3 whitespace-nowrap">
                          <span className="inline-block px-2 py-0.5 text-xs font-semibold rounded border bg-[#F3E8FF] text-[#673AB7] border-[#E9D5FF] dark:bg-purple-900/30 dark:text-purple-300">
                            {item.lead?.sourceName || "Unknown"}
                          </span>
                        </td>
                        <td className="px-4 py-3 text-[#4B5563] dark:text-gray-300 max-w-[200px] truncate" title={item.blackListLead?.reason}>
                          {item.blackListLead?.reason || "-"}
                        </td>
                        <td className="px-4 py-3 whitespace-nowrap font-medium text-[#4B5563] dark:text-gray-300">
                          {item.blackListLead?.createdByName || "-"}
                        </td>
                        <td className="px-4 py-3 whitespace-nowrap text-[#6B7280] dark:text-gray-400">
                          {formatDate(item.lead?.createdAt)}
                        </td>
                        {user?.accountType === "COMPANY" && (
                          <td className="px-4 py-3 whitespace-nowrap">
                            <button
                              onClick={() => handleDelete(item.blackListLead?.blackListLeadId)}
                              className="text-[#EF4444] hover:text-[#B91C1C] transition p-1.5 bg-gray-50 hover:bg-[#FEF2F2] dark:bg-gray-700 dark:hover:bg-gray-600 rounded-md shadow-sm"
                              title="Remove from Blacklist"
                            >
                              <FaTrash className="w-3.5 h-3.5" />
                            </button>
                          </td>
                        )}
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="10" className="text-center p-8 text-[#6B7280] dark:text-gray-400 bg-gray-50 dark:bg-gray-800/50 text-sm">
                        No blacklisted leads found.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}